export const PRESIDENTS_DAY_DEALS_PATH =
  "/deals/presidents-day-vacation-rentals"

// Friday Feb 13, 2026 12:00 AM PT through Tuesday Feb 17, 2026 12:00 AM PT.
const PRESIDENTS_DAY_HOME_START_PT_MS = Date.parse("2026-02-13T00:00:00-08:00")
const PRESIDENTS_DAY_HOME_END_PT_MS = Date.parse("2026-02-17T00:00:00-08:00")

export const isPresidentsDayHomeWindow = (nowMs = Date.now()): boolean =>
  nowMs >= PRESIDENTS_DAY_HOME_START_PT_MS &&
  nowMs < PRESIDENTS_DAY_HOME_END_PT_MS

export const isPresidentsDayDealsContext = (
  pathname?: string | null,
  nowMs = Date.now(),
): boolean =>
  Boolean(pathname?.startsWith(PRESIDENTS_DAY_DEALS_PATH)) ||
  (pathname === "/" && isPresidentsDayHomeWindow(nowMs))
